import { AmortizacionReadingDtoProps } from "./DTOs/AmortizacionReadingDto"
import { GetPrestamoByFiltersDtoProps } from "./DTOs/GetPrestamoByFiltersDto"

export function getPrestamoByFiltersDtoAdapter(
  prestamo: GetPrestamoByFiltersDtoProps
): GetPrestamoByFiltersDtoProps {
  return {
    id: prestamo.id,
    concepto: prestamo.concepto,
    deuda: prestamo.deuda,
    estado: prestamo.estado,
    fecha: prestamo.fecha,
    identificador: prestamo.identificador,
    importe: prestamo.importe,
    importeAmortizacion: prestamo.importeAmortizacion,
    importePendiente: prestamo.importePendiente,
    numero: prestamo.numero,
    razonSocial: prestamo.razonSocial,
    totalAmortizado: prestamo.totalAmortizado,
  }
}

export function adapterAmortizacionesPrestamo(
  amortizacion: AmortizacionReadingDtoProps
): AmortizacionReadingDtoProps {
  return {
    id: amortizacion.id,
    asientoContable: amortizacion.asientoContable,
    capitalVivo: amortizacion.capitalVivo,
    comisiones: amortizacion.comisiones,
    creationTime: amortizacion.creationTime,
    cuota: amortizacion.cuota,
    fecha: amortizacion.fecha,
    flujo: amortizacion.flujo,
    importe: amortizacion.importe,
    nota: amortizacion.nota,
    tipo: amortizacion.tipo,
    totalInteres: amortizacion.totalInteres,
  }
}
